<template>
  <standard-layout header="Neue Bestellung">
    <template v-slot:main>
      <div class="row h5">
        <div class="col-12"
             v-if="order.number">
          Bestellung {{ order.number }}
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <div>Kunde</div>
          <div>
            <Search @select="entrySelected($event)" type="customer"/>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-12">
              <label for="customerEmail">Email</label>
              <input id="customerEmail"
                     type="email"
                     class="form-control"
                     v-model="order.customer.email"/>
            </div>
            <div class="col-12 col-md-6 form-group">
              <label for="customerFirstName">Vorname</label>
              <input id="customerFirstName"
                     type="text"
                     class="form-control"
                     v-model="order.customer.firstName"/>
            </div>
            <div class="col-12 col-md-6 form-group">
              <label for="customerLastName">Nachname</label>
              <input id="customerLastName"
                     type="text"
                     class="form-control"
                     v-model="order.customer.lastName"/>
            </div>
            <div class="col-12 col-md-12">
              <label for="customerCompany">Firma</label>
              <input id="customerCompany"
                     type="text"
                     class="form-control"
                     v-model="order.customer.company"/>
            </div>
            <div class="col-12 col-md-12 form-group">
              <label for="customerStreetAndNumberInput">Straße und Nummer</label>
              <input id="customerStreetAndNumberInput"
                     type="text"
                     class="form-control"
                     v-model="order.customer.streetAndNumber"/>
            </div>
            <div class="col-4 col-md-3 form-group">
              <label for="customerZipInput">PLZ</label>
              <input id="customerZipInput"
                     type="text"
                     class="form-control"
                     v-model="order.customer.zip"/>
            </div>
            <div class="col-8 col-md-9 form-group">
              <label for="customerCityInput">Stadt</label>
              <input id="customerCityInput"
                     type="text"
                     class="form-control"
                     v-model="order.customer.city"/>
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-3">
        <div class="card-header">Bestellung</div>
        <div class="card-body">
          <div class="row">
            <div class="col-8">
              <article-selector v-model="selectedArticle"/>
            </div>
            <div class="col-2">
              <input v-model="selectedArticleQuantity"
                     class="form-control"
                     type="number"/>
            </div>
            <div class="col-2">
              <button class="btn-sm btn btn-primary" @click="addToOrder">Hinzufügen</button>
            </div>
          </div>
          <div class="card mt-3">
            <div class="card-header">Positionen</div>
            <div class="card-body">
              <div class="row">
                <div v-if="order.positions.length === 0"
                     class="col-12 text-muted">
                  Bestellung ist leer.
                </div>
              </div>
              <div class="row"
                   v-for="(position, idx) in order.positions"
                   :key="'pos_' + idx">
                <div :class="{'col-5 col-md-6': hasParameters(position.article.product),
             'col-8 col-md-9': !hasParameters(position.article.product)}">
                  {{ position.quantity }}&times;&nbsp;{{ position.article.product.name }}
                </div>
                <div v-if="hasParameters(position.article.product)"
                     class="col-3">
                  <label for="parameterInput">{{ parameter(position.article.product) }}</label>
                  <input id="parameterInput"
                         type="number"
                         class="form-control"
                         @input="updatePositionParameter(position, $event.target.value)"/>
                </div>
                <div class="col-4 col-md-3 text-right">
                  {{ position.totalGrossPrice|price }}
                </div>
              </div>
            </div>
          </div>
          <div class="mt-3">
            <div>zugehörige Bestellung</div>
            <div class="d-flex mt-1">
              <search ref="relatedToOrderIdSearch" type="order" @select="order.relatedToOrderId = ($event ? $event.id : null)"/>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 col-md-4 offset-md-8 text-right d-flex">
          <label for="totalGrossDiscountInput">Discount</label>
          <input id="totalGrossDiscountInput"
                 type="number"
                 class="form-control ml-1"
                 @input="updateTotalGrossDiscount($event.target.value)"/>
          <span class="ml-1">&euro;</span>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12 font-weight-bold text-right">
          Total: {{ order.totalGrossPrice|price }}
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-12 text-right">
          <div class="btn btn-primary"
               @click="submit">
            Bestellung speichern
          </div>
        </div>
      </div>
    </template>
  </standard-layout>
</template>

<script>
import StandardLayout from "@/layouts/StandardLayout";
import ArticleSelector from "@/components/shop/ArticleSelector";
import Search from "@/components/search/Search";

export default {
  data() {
    return {
      order: {
        number: undefined,
        customer: {
          id: undefined,
          email: undefined,
          firstName: undefined,
          lastName: undefined,
          streetAndNumber: undefined,
          zip: undefined,
          city: undefined,
          countryCode: 'de',
          phone: undefined
        },
        positions: [],
        reservation: {},
        state: undefined,
        totalGrossPrice: 0,
        totalGrossDiscount: 0
      },
      selectedArticle: null,
      selectedArticleQuantity: 1,
      relatedToOrderId: null
    }
  },
  computed: {
    customerName() {
      if (this.customer.firstName || this.customer.lastName)
        return this.customer.firstName + ' ' + this.customer.lastName
      return undefined
    }
  },
  methods: {
    async entrySelected(searchEntry) {
      if (searchEntry.type !== 'customer')
        this.showError('Bitte wähle einen Kunden')
      else {
        this.order.customer = await this.$api.get(`/customers/${searchEntry.id}`)
            .then(res => this.order.customer = res.data)
            .catch(err => this.handleError(err))
      }
    },
    addToOrder() {
      const orderPosition = {
        id: undefined,
        article: this.selectedArticle,
        quantity: this.selectedArticleQuantity,
        totalGrossPrice: this.selectedArticle.grossPrice * this.selectedArticleQuantity,
        vatRate: this.selectedArticle.vatRate
      }
      if (orderPosition.article.product.attendees > 0)
        this.updatePositionParameter(orderPosition, orderPosition.article.product.attendees)
      this.order.positions.push(orderPosition)
      this.updateTotalGrossPrice()
    },
    hasParameters(product) {
      return product.category === 'RES'
          || product.category === 'VOU'
    },
    parameter(product) {
      if (this.hasParameters(product)) {
        if (product.category === 'RES')
          return 'Teilnehmer'
        if (product.category === 'VOU')
          if (product.valueVoucher)
            return 'Wert'
          else
            return 'Teilnehmer'
      }
    },
    async updatePositionParameter(position, param) {
      const paramNumber = Number.parseInt(param)
      if (position.article.product.valueVoucher) {
        position.totalGrossPrice = paramNumber
      } else if (position.article.product.productVoucher || position.article.product.category === 'RES') {
        position.totalGrossPrice = position.article.grossPrice
        const addAttendees = paramNumber - position.article.product.attendees
        position.attendees = position.article.product.attendees + addAttendees
        const productIdToSearchAttendeeProductFor = position.article.product.productVoucher
            ? position.article.product.voucherProductForId
            : position.article.product.id
        if (addAttendees > 0) {
          position.totalGrossPrice += await this.$api.get(`/articles/attendee`, {
            params: {
              product: productIdToSearchAttendeeProductFor,
              channel: position.article.channel.id
            }
          }).then(res => res.data.grossPrice * addAttendees)
              .catch(err => this.handleError(err))
        }
      }
      this.updateTotalGrossPrice()
    },
    updateTotalGrossDiscount(discount) {
      this.order.totalGrossDiscount = discount
      this.updateTotalGrossPrice()
    },
    updateTotalGrossPrice() {
      let newTotalGross = this.order.positions.map(p => p.totalGrossPrice)
          .reduce((sum, price) => sum += price, 0)
      this.order.totalGrossPrice = newTotalGross - this.order.totalGrossDiscount
    },
    submit() {
      const payload = {
        ...this.order,
        totalVat: this.order.totalGrossPrice / 1.19 * 0.19
      }
      this.order.positions.forEach(p => p.totalVat = p.totalGrossPrice / (1 + p.vatRate) * p.vatRate)
      this.$api.post('/orders', payload)
          .then(response => this.$router.push({name: 'orderDetail', params: {id: response.data.id}}))
          .catch(error => this.handleError(error))
    }
  },
  mounted() {
    if (this.$route.query.order) {
      this.$api.get(`/orders/${this.$route.query.order}`)
          .then(response => this.order = response.data)
          .catch(error => this.handleError(error))
    }
  },
  components: {
    ArticleSelector,
    StandardLayout,
    Search
  }
}

</script>

<style type="scss">
</style>


